import React, { useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';

import styles from './learning-activity.style';
import { useColors } from '../../../../hooks';
import { useActivityContext } from '../../../../hooks/use-activity.context';
import LessonAccentBanner from '../../../lesson-accent-banner/lesson-accent-banner';
import LessonImage from '../../../lesson-image/lesson-image';
import LessonInstructions from '../../../lesson-instructions/lesson-instructions';
import LessonPlayerFrame from '../../../lesson-player-frame/lesson-player-frame';
import { StickAudioPlayer } from '../../../stick-audio-player/stick-audio-player';
import TranslatableHTML from '../../../translatable-html';

interface LearningActivityInterface {
  type: 'LEARNING' | 'LEARNING - EXTENDED';
  instructions: string;
  instructionsTranslation?: string;
  text: string;
  textTranslation?: string;
  image: string;
  audio?: string;
}

export function LearningActivity() {
  const colors = useColors();
  const activityContext = useActivityContext();
  const { completeCurrentActivity, isCurrentActivityComplete } =
    activityContext;
  const currentActivity =
    activityContext.currentActivity as LearningActivityInterface;
  const scrollY = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    completeCurrentActivity();
  }, [completeCurrentActivity]);

  return (
    <LessonPlayerFrame
      scrollY={scrollY}
      isButtonStuck={false}
      showContinueButton={isCurrentActivityComplete}
    >
      <LessonAccentBanner>
        <LessonInstructions
          translation={currentActivity.instructionsTranslation}
        >
          {currentActivity.instructions}
        </LessonInstructions>
      </LessonAccentBanner>
      {!!currentActivity.audio && (
        <StickAudioPlayer
          scrollY={scrollY}
          isSlowButtonVisible
          isTextProgressVisible
          barContainerColor={colors.primaryOpacity}
          inactiveColor={colors.onPrimary}
          activeColor={colors.onPrimary}
          url={currentActivity.audio}
          containerStyle={styles.audioPlayer}
        />
      )}
      <LessonImage imageUrl={currentActivity?.image} style={styles.image} />
      <View style={styles.content}>
        <View style={styles.innerContent}>
          <TranslatableHTML
            fontSize={18}
            style={styles.text}
            translation={currentActivity.textTranslation}
          >
            {currentActivity.text}
          </TranslatableHTML>
        </View>
      </View>
    </LessonPlayerFrame>
  );
}
